import styled from "styled-components";

export const ButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1% 2.5%;
  font-size: 0.875em;
  gap: 0.5rem;
  border-radius: 0.125rem;
  border: 0;
  transition: filter 0.2s;
  color: var(--white);
  background-color: var(--blue);
  &:hover {
    background-color: var(--dark-blue);
    filter: brightness(0.9);
  }

  &:disabled {
    background-color: var(--gray);
  }

  @media (max-width: 33.75rem) {
    font-size: 0.75rem;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;
